module.exports = __webpack_public_path__ + "assets/img/btn-view-mecha-info-3cc8fcf0.png";